import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import { currentFlowTypeEnum } from '../common/components/constants';
import { getProgramInfoInitiate } from '../../actions/programs';
import GiftingProgramInfo from './GiftingProgramInfo';

const mapStateToProps = state => {
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const viewOnlyMode = _get(state, 'user.view_only_mode', false);
  const programInfo = _get(state, 'programs.programInfo', {});
  const paymentRequestDetails = _get(programInfo, 'payment_request', {});

  return {
    currentFlow: currentFlowTypeEnum.FLOW_TYPE_GIFT_CARD,
    selectedWorkspace,
    viewOnlyMode,
    programInfo,
    paymentRequestDetails,
    fetchingProgramInfo:
      _get(state, 'apiState.GET_PROGRAM_INFO.isFetching', true) &&
      !_get(state, 'apiState.GET_PROGRAM_INFO.isIdle', false),
    fetchedProgramInfo: _get(state, 'apiState.GET_PROGRAM_INFO.success', true),
  };
};

const mapDispatchToProps = dispatch => ({
  getProgramInfo: payload => dispatch(getProgramInfoInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GiftingProgramInfo);
